export const createMemoryStorage = () => {
    const memoryStorage = new Map();
    return {
        crud: {
            get: async (key) => {
                return memoryStorage.get(key) ?? null;
            },
            set: async (key, value) => {
                memoryStorage.set(key, value);
                return key;
            },
            delete: async (key) => {
                memoryStorage.delete(key);
            },
            list: async () => {
                return Array.from(memoryStorage.keys());
            },
        },
    };
};
//# sourceMappingURL=memory-storage.js.map